import React from 'react';
import { Image } from 'react-konva';
import { useSvgImage } from '../../../pages/VectorLayoutEditor';

export default function VectorLayoutPreviewItem({ item, asset, layoutSize, canvasSize }) {
  const vectorImage = useSvgImage(asset?.svgText, item.strokeWidth || 4, item.strokeColor || '#000000');

  if (!asset || !vectorImage) return null;

  const scaleX = canvasSize.width / (layoutSize.width || canvasSize.width || 1);
  const scaleY = canvasSize.height / (layoutSize.height || canvasSize.height || 1);

  return (
    <Image
      image={vectorImage}
      x={(Number(item.x) || 0) * scaleX}
      y={(Number(item.y) || 0) * scaleY}
      width={(Number(item.width) || 100) * scaleX}
      height={(Number(item.height) || 100) * scaleY}
      rotation={Number(item.rotation) || 0}
      listening={false}
    />
  );
}
